<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :setLoading="setLoading"
    :persistenceKey="'sales-awaiting-list'"
    :loadDataGrid="loaded"
    ref="sales-awaiting-list"
    v-if="loaded"
  >
    <template #popup>
      <GcPopUpWorkOrder
        :popupConfig="popup"
        :on-hide="onPopupHide"
        :wrapper-attr="{
          class: 'css-v2 gc-popup gc-popup-form gc-popup-work-order',
        }"
        :data-model="dataModel"
        :show-loading="showLoading"
        :width="1024"
        :height="370"
        :save-call-back="onWorkOrderSave"
        :displayServerError="displayServerErrorOnTemplate"
        v-if="popup.isPopupShow"
      />
    </template>
  </TransactionListTemplate>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";

import TransactionListTemplate from "../../templates/transaction-list";
import {
  GetIndexByTabName,
  WorkOrderTabs,
} from "../../_models/tabdata/production/work-order-tabs";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import { WorkOrderService } from "../../_services/api/production/work-order.service";
import { FeatureStorage } from "../../_services/storage";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      setLoading: false,
      CustomerSalesRepresentativeCode: undefined,
      loaded: false,
      popup: {
        title: "",
        secondaryTitle: undefined,
        isFormLoading: false,
        popupKey: 0,
        formKey: 0,
        height: 370,
        isPopupShow: false,
        hideOnOutsideClick: false,
        formMode: "create",
        isEditable: false,
      },
      dataModel: undefined,
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Work Orders",
        ScreenName: "Sales Orders - Planning",
        selectedIndex: GetIndexByTabName("Sales Awaiting Planning"),
        tabs: WorkOrderTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "SalesOrderDetailCompanyBranch",
              filter: [
                ["ItemType", "=", "S"],
                "and",
                ["ProductionStatus", "=", "Awaiting Planning"],
                "and",
                ["Status", "=", "A"], // list should only display the sales order line with sd.SPLNSTAT = 'A'
              ],
              serverPaging: true,
              allowGrouping: false,
              // select: [
              //   "SalesOrderCode",
              //   "CustomerCode",
              //   "CustomerName",
              //   "CustomerOrder",
              //   "LineNo",
              //   "ItemCode",
              //   "Description1",
              //   "MarketCode",
              //   "ShipDate",
              //   "WorkOrderCode",
              //   "WorkOrderPackDate",
              //   "SalesOrderFriendlyStatus",
              //   "BranchCode",
              //   "TransportStatus",
              //   "ProductionStatus",
              //   "RecordId",
              //   "ProductionStatusHexColour",
              //   "TransportStatusHexColour",
              //   "ItemType",
              // ],
              keyType: {
                ...this.getAttributeKeyTypes(),
              },
            },
            // noDataMessage: {
            //   addNew: {
            //     class: "add-new",
            //     title: "No Orders",
            //     message: "Get Started, Add an Order",
            //   },
            // },
            options: {
              selectionMode: "multiple",
              // pageSize: 50,
            },
          },
          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            filterOnEnter: true,
            customButtons: [
              {
                icon: "more",
                widget: "dxDropDownButton",
                label: "",
                clickAction: {},
                buttonLocation: "right",
                options: {
                  icon: "more",
                  showArrowIcon: false,
                  keyExpr: "menuText",
                  displayExpr: "menuText",
                  dropDownOptions: { width: 150 },
                  items: [
                    {
                      menuText: "Create Work Order",
                    },
                  ],
                  onItemClick: this.createWorkOrder,
                  disabled: !FeatureStorage.checkPermission(
                    "WorkOrder",
                    "create",
                  ),
                },
              },
            ],
          },
          columns: [
            {
              screenField: "SalesOrder",
              gridDataField: "SalesOrderCode",
              dataField: "SalesOrderCode",
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              width: ColumnWidth.SalesOrderCode.width,
              maxWidth: ColumnWidth.SalesOrderCode.minWidth,
              hyperlink: {
                url: "sales-order/review/__ID__",
                target: "_blank",
              },
            },
            {
              screenField: "Code",
              label: "Product Code",
              dataField: "ItemCode",
              allowHiding: false,
              width: ColumnWidth.ProductCode.width,
            },
            {
              screenField: "Code",
              filterLabel: "Sales Order",
              showInColumnChooser: false,
              visible: false,
              type: "Integer",
              filterIndex: 0,
              width: ColumnWidth.SalesOrderCode.width,
              maxWidth: ColumnWidth.SalesOrderCode.minWidth,
              filterDataField: "SalesOrderCode",
            },
            {
              screenField: "ShipDate",
              gridLabel: "Ship Date",
              filterDataField: "ShipDate",
              filterIndex: 3,
              width: ColumnWidth.Date.width,
              maxWidth: ColumnWidth.Date.minWidth,
              sortOrder: "asc",
              sortIndex: 1,
              allowHiding: false,
            },
            {
              caption: "Stock UM Qty",
              gridLabel: "Stock UM Qty",
              dataField: "StockUMQty",
              minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
              width: ColumnWidth.Quantity4DecimalPoints.width,
              format: "##,###,###,###,##0.0000",
              cellTemplate: "Decimal",
            },
            {
              screenField: "StockUM",
              dataField: "StockUM",
              caption: "Stock UM",
              minWidth: ColumnWidth.UnitOfMeasure.minWidth - 5,
              width: ColumnWidth.UnitOfMeasure.width - 5,
              allowSorting: true,
              visible: false,
            },
            {
              caption: "Notes",
              dataField: "Notes",
              cellTemplate: (data, info) => {
                return (data.innerHTML = `<div class='comment-cell-template'>${info.text}</div>`);
              },
              minWidth: ColumnWidth.Comment.minWidth,
              customizeText: (e) => {
                if (e.value) return e.value.replaceAll("\n", "<br/>\r\n");
                else return "";
              },
            },
            {
              screenField: "Customer",
              filterIndex: 2,
              allowHiding: false,
            },
            {
              screenField: "CustPO",
              gridDataField: "CustomerOrder",
              filterDataField: "CustomerOrder",
              dataType: "string",
              type: "Text",
              filterIndex: 1,
              width: ColumnWidth.CustPO.width,
              maxWidth: ColumnWidth.CustPO.minWidth,
            },
            {
              screenField: "Product",
              gridDataField: "Description1",
              allowHiding: false,
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "Description1",
                  },
                ],
                secondary: [
                  {
                    dataField: "ItemCode",
                  },
                ],
              },
              exportFields: [
                // {
                //   dataField: "ItemCode",
                //   label: "Product Code",
                // },
                {
                  dataField: "Description1",
                  label: "Product Description",
                },
              ],
              filterIndex: 2,
              filterDataField: "ItemCode",
              filterOverWrites: {
                select: [
                  "Code",
                  "Description1",
                  "Inactive",
                  "Status",
                  "Source",
                ],
                filter: [
                  ["Inactive", "=", "N"],
                  "and",
                  ["Status", "=", "A"],
                  "and",
                  ["Source", "=", "M"],
                ],
              },
            },
            {
              screenField: "BOM",
              label: "BOM",
              filterDataField: "BomCode",
              filterIndex: 3,
              visible: false,
              showInColumnChooser: false,
            },
            {
              screenField: "LineComment",
              gridLabel: "Line #",
              dataField: "LineNo",
              width: ColumnWidth.LineInfo.width - 20,
              minWidth: ColumnWidth.LineInfo.minWidth - 20,
              alignment: "left",
              allowSorting: true,
              visible: false,
            },
            {
              screenField: "Market",
              gridDataField: "MarketCode",
              width: ColumnWidth.Market.width,
              maxWidth: ColumnWidth.Market.minWidth,
              filterDataField: "MarketCode",
              filterIndex: 9,
              visible: false,
            },
            {
              screenField: "WorkOrder",
              gridDataField: "WorkOrderCode",
              width: ColumnWidth.WorkOrder.width,
              maxWidth: ColumnWidth.WorkOrder.minWidth,
              cellTemplate: undefined,
              hyperlink: true,
              hyperLinkCallBack: this.hyperLinkCallBack,
              visible: false,
            },
            {
              screenField: "RequiredByDate",
              gridLabel: "Pack Date",
              filterLabel: "Pack Date",
              gridDataField: "WorkOrderPackDate",
              filterDataField: "WorkOrderPackDate",
              width: ColumnWidth.Date.width,
              maxWidth: ColumnWidth.Date.minWidth,
              sortOrder: "asc",
              sortIndex: 0,
              visible: false,
              filterIndex: 4,
            },
            // {
            //   screenField: "ProductionStatus",
            //   width: 120,
            //   // filterIndex: 6,
            //   customBackGroundColor: (data) => {
            //     if (data) return data.ProductionStatusHexColour;
            //     else return undefined;
            //   },
            // },
            {
              screenField: "TransportStatus",
              filterIndex: 7,
              customBackGroundColor: (data) => {
                if (data) return data.TransportStatusHexColour;
                else return undefined;
              },
            },
            {
              screenField: "Branch",
              filterDataField: "BranchCode",
              visible: false,
              showInColumnChooser: false,
              filterIndex: 5,
              filterOverWrites: {
                select: ["Code", "Description", "Inactive", "ManufactureFlag"],
                filter: [
                  ["Inactive", "=", "N"],
                  "and",
                  ["ManufactureFlag", "=", "Y"],
                ],
              },
            },
            {
              screenField: "OrderStatus",
              filterDataField: "SalesOrderFriendlyStatus",
              filterIndex: 8,
              visible: false,
              showInColumnChooser: false,
              dataSourceConfig: {
                data: [
                  "Active",
                  "Cancelled",
                  "Completed",
                  "Draft",
                  "Locked",
                  "On Hold",
                  "Pending",
                ],
              },
              filterDefaultValue: ["Active", "Locked"],
            },
            {
              screenField: "GridRecordEllipsisMenu",
              cssClass: "padding-7",
              allowSearch: false,
              ellipsisMenu: {
                itemAction: (data) => {
                  var items = [
                    {
                      menuText: "Create Work Order",
                      data: data,
                      clickAction: this.createWorkOrder,
                    },
                  ];

                  return items;
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
              makeDisabled: () => {
                return !FeatureStorage.checkPermission(
                  "SalesOrderPlanning",
                  "create",
                );
              },
            },
            {
              screenField: "ProductCategory1",
              label: "Category 1",
              filterLabel: "Category 1",
              filterIndex: 10,
              visible: false,
              showInColumnChooser: false,
            },
            {
              screenField: "ProductCategory2",
              label: "Category 2",
              filterLabel: "Category 2",
              filterIndex: 11,
              visible: false,
              showInColumnChooser: false,
            },
            {
              screenField: "ProductCategory3",
              label: "Category 3",
              filterLabel: "Category 3",
              filterIndex: 12,
              visible: false,
              showInColumnChooser: false,
            },
            {
              screenField: "ProductCategory4",
              label: "Category 4",
              filterLabel: "Category 4",
              filterIndex: 13,
              visible: false,
              showInColumnChooser: false,
            },
            {
              screenField: "ProductType",
              label: "Type",
              filterLabel: "Type",
              filterIndex: 14,
              visible: false,
              showInColumnChooser: false,
            },
          ].concat(this.getAttributeColumns(14, false, false)),
        },
      };

      return config;
    },
  },
  methods: {
    createWorkOrder(e) { 
      if (e.itemElement) {
        let selectedRows =
          this.$refs["sales-awaiting-list"].$refs[
            "transactionListGrid"
          ].selectedRowData();

        if (selectedRows.length > 0)
          this.launchWorkOrderModelWithSOLiles(selectedRows);
        else {
          this.$alert("Select one more sales order lines to continue", "Error");
        }
      } else {
        if (e) this.launchWorkOrderModelWithSOLiles([e]);
      }
    },
    async launchWorkOrderModelWithSOLiles(soLines) {
      let filter = this.createODataFilter(soLines);
      if (filter) {
        this.showLoading(true);
        await WorkOrderService.getWorkOrderSalesOrderLines(filter)
          .then((res) => {
            this.showLoading(false);
            if (res.data.value.length != soLines.length) {
              this.$alert(
                "One or more sales order lines are linked to a Draft, Active, In Production, or Completed Work Order. Please remove the linked sales order line and try again.",
                "Error",
              );
            } else {
              this.$nextTick(() => {
                if (this.allItemsHaveSameCode(soLines))
                  this.popup.BomCode = soLines[0].BomCode;
                else this.popup.BomCode = undefined;
                this.popup.soLines = res.data.value;
                this.popup.title = "Create Work Order";
                this.popup.secondaryTitle = undefined;
                this.popup.formMode = "create";
                this.popup.hideOnOutsideClick = false;
                this.popup.formKey++;

                this.popup.triggerEdit = false;
                this.popup.displayForScheduleEditing = false;

                this.popup.isPopupShow = true;
              });
            }
          })
          .catch((err) => {
            this.showLoading(false);
            this.displayServerError(err, "SO Lines");
          });
      }
    },

    allItemsHaveSameCode(array) {
      if (array.length === 0) return false; // Empty array case
      const firstItemCode = array[0].ItemCode;

      for (const item of array) {
        if (item.ItemCode !== firstItemCode) {
          return false; // Mismatch found, return early
        }
      }
      return true; // All match
    },

    createODataFilter(elements) {
      if (!Array.isArray(elements) || elements.length === 0) {
        return ""; // Return empty string if array is empty or not provided
      }

      const filters = elements.map(
        (element) =>
          `(SalesOrderCode eq ${element.SalesOrderCode} and SalesOrderLine eq ${element.LineNo})`,
      );

      return filters.join(" or ");
    },
    /**
     * Show Loading
     * @param value
     * @constructor
     */
    showLoading(value) {
      this.setLoading = value;
    },

    /**
     * Hide work order popup
     */
    onPopupHide() {
      this.popup.isPopupShow = false;
      this.popup.BomCode = undefined;
      this.popup.soLines = [];
    },

    /**
     * call back after wo-model save event
     */
    onWorkOrderSave(close = true) {
      if (close) {
        this.onPopupHide();
        this.showLoading(true);
      }

      let dataGrid =
        this.$refs["sales-awaiting-list"].$refs[
          "transactionListGrid"
        ].getGridInstance();
      if (dataGrid) {
        dataGrid.deselectAll();
      }

      if (this.popup.displayForScheduleEditing) {
        WorkOrderService.getByCode(this.popup.workOrderCode).then(
          (response) => {
            const workOrderDetail = response.data.value[0];
            this.dataModel = workOrderDetail;
            this.dataModel.FriendlyStatus = workOrderDetail.FriendlyStatus;

            this.popup.title = `Work Order #${workOrderDetail.Code}`;
            this.popup.workOrderCode = workOrderDetail.Code;
            this.popup.secondaryTitle =
              workOrderDetail.ProductCode +
              " - " +
              workOrderDetail.ProductDescription;
            this.popup.isEditable = true;
            this.popup.triggerEdit = FeatureStorage.checkPermission(
              "WorkOrder",
              "edit",
            );

            this.$nextTick(() => {
              this.showModalReview();
            });
          },
        );
      } else {
        this.$refs["sales-awaiting-list"].$refs[
          "transactionListGrid"
        ].gridRepaint();

        this.$nextTick(() => {
          this.showLoading(false);
        });
      }
    },
    /**
     * display server error
     * @param err
     * @param msg
     */
    displayServerErrorOnTemplate(err, msg) {
      this.$store.dispatch("ui/setServerError", {
        error: err,
        title: msg,
      });
    },

    /**
     * grid table row call back
     */
    rowClickCallBack() {
      return false;
    },

    /**
     * Hyperlink call back for visible wo-popup model
     */
    async hyperLinkCallBack(data) {
      let rowData = data.data;
      const response = await WorkOrderService.getByCode(rowData.WorkOrderCode);
      const workOrderDetail = response.data.value[0];
      this.dataModel = workOrderDetail;
      // this.dataModel.FriendlyStatus = rowData.SalesOrderFriendlyStatus;

      this.popup.title = `Work Order #${workOrderDetail.Code}`;
      this.popup.workOrderCode = workOrderDetail.Code;
      this.popup.secondaryTitle =
        rowData.ItemCode + " - " + rowData.Description1;
      this.popup.isEditable =
        (this.dataModel.FriendlyStatus === "Active" ||
          this.dataModel.FriendlyStatus === "In Production") &&
        FeatureStorage.checkPermission("WorkOrder", "edit");

      this.showModalReview();
    },

    /**
     * Show Modal Review
     */
    showModalReview() {
      this.popup.hideOnOutsideClick = true;
      this.popup.formMode = "review";
      this.popup.popupKey++;
      this.popup.isPopupShow = true;
    },
  },

  async created() {
    this.setLoading = true;

    this.$nextTick(() => {
      this.setLoading = false;
      this.loaded = true;
    });
  },
};
</script>

<style lang="scss"></style>
